import { Grid } from "@material-ui/core";
import { useDevice } from "components/DeviceContext.js";
import InformacoesCNM from "components/InformacaoCNM";

function Footer() {
    const {isMobile} = useDevice();
    return (
        <Grid>
            <InformacoesCNM />
            <footer style={{
                backgroundColor: 'var(--azul)',
                margin: 0,
                padding: 0,
            }}>
                <div style={{
                    fontSize: isMobile ? '12px' : '15px',
                    padding: '0.6em',
                    textAlign: 'center',
                    color: 'var(--branco)',
                    margin: 0,
                }}>
                    <p style={{
                    }}>
                        © 2024 Confederação Nacional de Municípios. Todos os direitos reservados. Todo o conteúdo produzido pode ser reproduzido, desde que citada a fonte.
                    </p>
                </div>
            </footer>
        </Grid>
    );
}

export default Footer;
